import { INTEGRATION_CODE } from "../../../../../models/IntegrationsTypes";
import { makeAutoObservable } from "mobx";
import { ICredentialsStore } from "../integration-store";
import IntegratorOAuthHandler from "./integrator-oauth-handler/integrator-oauth-handler";

class YotpoCredentialsStore implements ICredentialsStore {
    private _oauthHandler = new IntegratorOAuthHandler(INTEGRATION_CODE.YOTPO);

    constructor() {
        makeAutoObservable(this);
    }

    getCredentials() {
        return this._oauthHandler.getCredentials();
    }
}

export default YotpoCredentialsStore;
